<template>
    <div v-if="this.results.length > 0" class="form-items-container mt-3">
        <div v-for="form in results" class="question-container-results"> 
            <div class="form-result-title mb-3">
                <strong><a :href="'../onboarding/'+form.category+'?form='+form.form_id" target="_blank">{{ form.name }}</a></strong>
            </div>
            <div v-for="(field, index) in form.fields" :key="index" class="row">
                <div v-if="field.show || (!field.show && field.results.length > 0)" class="col-sm-12 col-md-12">
                    <header class="panel row">
                        <h3 class="col-sm-12 pr-0">
                            <div class="panel-left float-left">
                                <div class="btn btn-primary btn-sm badge-counter mr-3">{{ index+1 }}</div> {{ field.question_title }}
                                
                            </div>
                            <div class="float-right text-muted">
                                <span v-if="field.answer_type == 'text'"><app-icon :name="'message-square'" width="20" height="20" class="text-muted mr-4"/></span>
                                <span v-else><app-icon :name="'check-square'" width="20" height="20" class="text-muted mr-4"/></span>
                            </div>
                        </h3> 
                    </header>
                </div>
                <div v-if="field.show || (!field.show && field.results.length > 0)" class="col-sm-12 col-md-12">
                    <div v-for="(result, index) in field.results" :key="index" :class="index == field.results.length - 1 ? 'row mb-2 form-result-answer no-border' : 'row mb-2 form-result-answer'">   
                        <div class="col-sm-12 col-md-5 pl-4">
                            {{ result.answer_text }}
                        </div>
                        <div v-if="field.answer_type == 'radio'" class="col-sm-12 col-md-1 text-right">
                            <div v-if="result.correct == 1" class="questionnaire-mark questionnaire-mark-perfect"></div>
                            <div v-else class="questionnaire-mark questionnaire-mark-wrong"></div>
                        </div>
                        <div v-else class="col-sm-12 col-md-1 text-right">
                            
                        </div>
                        <div class="col-sm-12 col-md-2 p-0">
                            <div>
                                <app-icon :name="'user'" width="20" height="20" class="text-muted mr-2"/>
                                <a :href="'../onboarding?profile='+result.candidate.id" target="_blank">{{ result.candidate.name }} {{ result.candidate.surname }}</a>
                            </div>   
                        </div>    
                        <div class="col-sm-12 col-md-4 text-right">
                            <span v-if="result.deadline_day < 0" class="btn btn-primary btn-sm badge-counter badge-counter-large badge-counter-warning mr-3">{{ result.deadline_day*(-1) }} dny po termínu</span>

                            {{ formatEventDate(result.updated_at) }}
                            
                        </div>                        

                    </div>
                    <div v-if="field.results.length == 0" class="text-center text-muted p-3 pt-0">
                        ({{ $t('in_the_last_30_days_no_answers') }})
                    </div>
                </div>
            </div>
            </div>
        </div>

    </div>
    <div v-else>
        <div class="offset-md-2 col-md-8 mt-4 text-center">
            <h5><app-icon :name="'clock'" class="mr-2" width="18" height="18"/> <b>{{ $t('no_anwsers_yet') }}</b></h5><br><br>
        </div>
    </div>
</template>

<script>
    import * as actions from "../../../../../Config/ApiUrl";

    export default {
        name: "resultListDatatable",
        props: {
           results: [Array, Object],
        },
        data() {
            return {
                preloader: false,
            }
        },
        methods: {
            formatEventDate(date) {
                let formattedDate = ' – '+this.$t('no_date');
                if(date){
                    formattedDate = moment(date).format('DD. MM. YYYY, HH:mm');
                    this.hasEventDate = true;
                }
                return formattedDate;

            },
        },
    }
</script>
